/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  LoggerUpdateLog,
  ResponseStatusType,
} from '..';
import {
  serializeLoggerUpdateLog,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface InsertLoggerUpdateLogInput {
  input?: LoggerUpdateLog;
}
const build = (_query: DocumentNode, input: InsertLoggerUpdateLogInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.input !== undefined ? `$input: LoggerUpdateLog = ${serializeLoggerUpdateLog(input.input)}` : '' ) + `){
    insertLoggerUpdateLog(
      ${ input.input !== undefined ? 'input: $input,' : '' }
    ){
      ...responsestatustype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class InsertLoggerUpdateLogMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment responsestatustype on ResponseStatusType { ... }
   */
  async execute(_query: DocumentNode, input: InsertLoggerUpdateLogInput): Promise<apollo.FetchResult< { insertLoggerUpdateLog: Partial<ResponseStatusType> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ insertLoggerUpdateLog: Partial<ResponseStatusType> }>({ mutation: build(_query, input) });
  }
}
